/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum IncidentStatusEnums {
    IN_PROGRESS = 1,
    SUBMITTED = 2,
    UNDER_REVIEW = 3,
    CLAIM_CREATED = 4,
    REPORT_ONLY = 5,
    DENIED = 6,
    FIRST_AID = 7,
    DELETED = 8,
}
